'use strict';

/**
 * Converts milliseconds to seconds
 * @param ms milliseconds
 * @returns seconds
 */
export function msToSeconds(ms: number): number {
  return ms / 1000;
}

/**
 * Converts milliseconds to minutes
 * @param ms milliseconds
 * @returns minutes
 */
export function msToMinutes(ms: number): number {
  return ms / (1000 * 60);
}

/**
 * Converts milliseconds to hours
 * @param ms millieconds
 * @returns hours
 */
export function msToHours(ms: number): number {
  return ms / (1000 * 60 * 60);
}

/**
 * Converts seconds to milliseconds
 * @param seconds
 * @returns milliseconds
 */
export function secondsToMs(seconds: number): number {
  return 1000 * seconds;
}

/**
 * Converts minutes to milliseconds
 * @param minutes minutes
 * @returns milliseconds
 */
export function minutesToMs(minutes: number): number {
  return 1000 * 60 * minutes;
}

/**
 * Converts minutes to seconds
 * @param minutes minutes
 * @returns seconds
 */
export function minutesToSeconds(minutes: number): number {
  return minutes * 60;
}

/**
 * Converts hours to milliseconds
 * @param hours hours
 * @returns milliseconds
 */
export function hoursToMs(hours: number): number {
  return 1000 * 60 * 60 * hours;
}

/**
 * Converts hours to minutes
 * @param hours hours
 * @returns minutes
 */
export function hoursToMinutes(hours: number): number {
  return 60 * hours;
}
